export const InSensitiveArr = ['internal_attributes[od_cd]', 'internal_attributes[os_cd]'];

// additionalTest fields 0 to 14 (don't change its indexing)
export const AdditionalTestTypes = [
  { visual_summary_field: ['order', 'interpretation'] }, // 0
  { amsler_grid: [] }, // 1
  { external_imaging: ['order', 'interpretation'] }, // 2
  { internal_imaging: ['order', 'interpretation'] }, // 3
  { oct: ['order', 'interpretation'] }, // 4
  { topography: ['order', 'interpretation'] }, // 5
  { punctal_plug: ['location', 'plug_type', 'pre_medication', 'post_medication'] }, // 6
  { epilation: ['location', 'number'] }, // 7
  { foreign_body_removal: ['location', 'tool_used', 'post_op_medication'] }, // 8
  { skin_tag_removal: ['location', 'post_op_medication'] }, // 9
  { amniotic_membrane: ['post_op_medication', 'insertion_method', 'am_type'] }, // 10
  { pachymetry: ['pachymetry'] }, // 11
  { inflamma_dry: ['inflamma_dry'] }, // 12
  { tear_lab: ['tear_lab'] }, // 13
  { digital_retina_wellness_screening: ['order', 'interpretation'] } // 14
];

export const getEyeCode = (name) => {
  // [od]
  let fieldLastSecondArr = name.split('[')[name.split('[').length - 2].replaceAll(']', '')
  const match = name.match(/\b(OD|OS|OU)\b/i);
  return match ? `[${fieldLastSecondArr}][${match[0]}]` : null;
};

export const getEyeCodeInSensitive = (name) => {
  // [od_cd]
  let fieldLastSecondArr = name.split('[')[name.split('[').length - 2].replaceAll(']', '')
  const match = name.match(/(OD|OS|OU)/i);
  return match ? `[${fieldLastSecondArr}][${match[0]}]` : null;
};

export const findFieldModule = (fieldName) => {
  const isExternal = fieldName.includes('external_attributes[');
  const isInternal = fieldName.includes('internal_attributes[');
  const isAdditional = fieldName.includes('additional_tests_attributes[');
  return { isExternal, isInternal, isAdditional }
}

export const getAdditionalTestTypeName = (fieldName, setting) => {
  const index = setting ? fieldName.split('][')[1] : fieldName.split('[')[1].split(']')[0];
  const item = AdditionalTestTypes[index];
  const key = Object.keys(item)[0];
  // return test_type name for additional_test as per required at BE
  const parts = fieldName.split('[');
  const lastPart = parts[parts.length - 1].replaceAll(']', '');
  return `${key}_${lastPart}`;
};